<template>
  <div class="createOrder_box">
    <div class="page_title">
      <custom-breadcrumb/>
    </div>
    <p class="con_title">Customer</p>
    <div class="order_search">
      <!-- <el-input
        class="search_input"
        v-model="searchWords"
        prefix-icon="el-icon-search"
        @change="changSelectHandel()"
        placeholder="Product name / Brands / Category"
        clearable
        filterable
      /> -->
      <el-select v-model="searchWords" clearable filterable placeholder="Retailer Name/Email"
                 @change="changSelectHandel()">
        <el-option
          v-for="item in retailerInfo"
          :key="item.id"
          :label="item.email"
          :value="item.email">
          <div class="flex re_text">
            <p>{{ item.email }}</p>
            <p style="color: #8492a6;font-size: 13px">{{ item.storeName }}<span
              class="span_margin">|</span>{{ item.phone }}</p>
          </div>
        </el-option>
      </el-select>
      <div v-if="retailerInfo.length == 1">
        <div
          class="search_content flex"
          v-for="(user, index) in retailerInfo"
          :key="index"
        >
          <div class="con_left">
            <p class="con_title">Customer</p>
            <p class="user_info">
              Username: <span class="info_text">{{ user.username }}</span>
            </p>
            <p class="user_info">
              Email: <span class="info_text">{{ user.email }}</span>
            </p>
            <p class="user_info">
              Phone: <span class="info_text">{{ user.phone }}</span>
            </p>
            <p class="user_info">
              Store name: <span class="info_text">{{ user.storeName }}</span>
            </p>
          </div>
          <div class="con_right">
            <p class="con_title">
              Ship To
              <span @click="openAddress">
                <img src="@/assets/img/memo.png" alt="">
              </span>
            </p>
            <div>
              <p class="user_info" v-if="reInfo.addressFirstName&&reInfo.addressLastName">{{ reInfo.addressFirstName }}&nbsp;&nbsp;{{
                  reInfo.addressLastName
                }}<br/>
              </p>
              <p class="user_info" v-if="reInfo.address">{{ reInfo.address }}<br/></p>
              <p class="user_info" v-if="reInfo.city&&reInfo.province &&reInfo.countryName && reInfo.postCode">
                {{ reInfo.city }}, {{ reInfo.province }}, {{ reInfo.countryName }}&nbsp;&nbsp;{{ reInfo.postCode }}<br/>
              </p>
              <p class="user_info" v-if="reInfo.addressPhone">
                {{ reInfo.areaCode }}{{ reInfo.addressPhone }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p class="con_title">Order details</p>
    <div class="creat_order">
      <el-table :data="orderDetails" border style="width: 100%">
        <el-table-column prop="date" label="Item" width="420">
          <template slot-scope="scope">
            <div class="prduct_box">
              <img class="product_img" :src="scope.row.img" alt=""/>
              <div class="product_info">
                <p class="product_name">
                  {{ scope.row.title }}
                </p>
                <p class="product_size">
                  {{ scope.row.size }}
                  <span style="color: #8F8F8F;margin-left: 15px;font-size: 14px;"> {{ scope.row.skuCode }}</span>

                </p>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="FOB Price" width="180">
          <template slot-scope="scope">
            <div class="prduct_box flex_all">
              <el-input
                class="price_input"
                v-model="scope.row.fobPrice"
                placeholder="FOB Price"
                oninput="if(value){value=value.replace(/[^0-9.]/g,'')} if(value){value=value.replace(/^()*(\d+)\.(\d\d).*$/, '$1$2.$3')}"
                @change="(e)=>changeFobPrice(e,scope.$index,scope.row)"
              />
              <div v-if="scope.row['fobPriceBefore'] !=scope.row['fobPrice']"
                   :class="scope.row['fobPriceBefore'] !=scope.row['fobPrice']?'dis_price dis_line':'dis_price'">
                ${{ scope.row.fobPriceBefore }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Wholesale Price" width="150">
          <template slot-scope="scope">
            <div class="prduct_box flex_all">
              {{ scope.row.price | fixed2 }}
              <div v-if="scope.row['priceBefore'] !=scope.row['price'] "
                   :class="scope.row['priceBefore'] !=scope.row['price'] ?'dis_price dis_line':'dis_price'">
                ${{ scope.row['priceBefore'].toFixed(2) }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="Qty" width="150">
          <template slot-scope="scope">
            <div class="prduct_box flex_all qty-left">
              <el-input
                class="price_input"
                v-model="scope.row.sum"
                oninput="if(value){value=value.replace(/[^\d]/g,'')}  if(value<1){value=1}"
                placeholder="Qty"
                @change="(e)=>changeNum(e,scope.$index,scope.row)"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="Total">
          <template slot-scope="scope">
            <span>${{ scope.row.total | fixed2 }}</span>
            <span class="order-delete" @click="deleteOrder(scope.row)"><i class="el-icon-close"></i></span>
          </template>
        </el-table-column>
      </el-table>
      <el-button type="primary" class="add-btn" @click="addProductHandel()"
      >Add Product
      </el-button
      >
    </div>
    <div class="product-bottom">
      <div class="product-bottom-memo">
        <div>
          <div class="memo-text">Memo</div>
          <div>
            <el-input
              type="textarea"
              rows="8"
              placeholder="Fill out Memo"
              maxlength="500"
              show-word-limit
              v-model="memo"
              @keydown.native="memoChange($event)"
            >
            </el-input>
          </div>
        </div>
      </div>
      <div class="product-bottom-price">
        <div class="end_box flex" v-if="orderDetails && orderDetails.length>0">

          <div class="creat_text flex">
            <p>Qty</p>
            <p>{{ totalInfo['totalQuantity'] }}</p>
          </div>

          <div class="creat_text flex" v-if="brandName">
            <p>{{ this.brandName }}</p>
            <p>{{ totalInfo['cifSubTotal'] | fixed2 }}</p>
          </div>
          <div class="creat_text flex" v-if="brandName">
            <p></p>
            <p style="color: #5D5D5D;">(FOB Subtotal ${{ totalInfo['fobSubtotal'] | fixed2 }})</p>
          </div>
          <div class="creat_text flex">
            <p class="brown_text">Product discount</p>
            <p class="brown_text">
              <span class="black_text">-</span>${{ totalInfo['totalPriceProductDicounted'] | fixed2 }}
            </p>
          </div>
          <div class="creat_text flex">
            <p class="brown_text">Bulk order discount</p>
            <p class="brown_text">
              <span class="black_text">-$</span>
              <el-input
                class="price_input brown_text"
                oninput="if(value){value=value.replace(/[^0-9.]/g,'')} if(value){value=value.replace(/^()*(\d+)\.(\d\d).*$/, '$1$2.$3')}"
                v-model="totalInfo['totalPriceOrderDiscounted']"
                placeholder=""
                clearable
                @change="changePrice"
              />
            </p>
          </div>

          <div class="creat_text flex" v-if="totalInfo['totalPriceOrderDiscountedShopvidi']">
            <p class="brown_text">Offered by ShopVidi</p>
            <p class="brown_text">
              <span class="black_text">-$</span>
              {{ totalInfo['totalPriceOrderDiscountedShopvidi'] | fixed2 }}
            </p>
          </div>
          <div class="creat_text flex">
            <div class="split"></div>
          </div>
          <div class="creat_text flex" style="font-weight: 600;">
            <p>Subtotal</p>
            <p>${{ totalInfo['subTotal'] | fixed2 }}</p>
          </div>
          <div class="creat_text flex">
            <p>Shipping</p>
            <p class="brown_text">
              <span class="black_text">{{ shippingPrice || 0 }}</span>
            </p>
          </div>
          <div class="creat_text flex">
            <p class="brown_text">Shipping discount (By Brand)</p>
            <p class="brown_text">
              <span class="black_text">-$</span>
              <el-input
                class="price_input brown_text"
                oninput="if(value){value=value.replace(/[^0-9.]/g,'')} if(value){value=value.replace(/^()*(\d+)\.(\d\d).*$/, '$1$2.$3')}"
                v-model="totalInfo['shippingDiscount']"
                placeholder=""
                clearable
                @change="handleShippingDiscount"
              />
            </p>
          </div>
          <div class="creat_text flex">
            <div class="split"></div>
          </div>
          <div class="creat_text blod_text flex">
            <p>Total Amount</p>
            <p>{{ totalInfo['payAmount'] | fixed2 }}</p>
          </div>
          <el-button type="primary" class="add-btn" :loading="createOrderLoading" @click="createOrder()"
          >Create Order
          </el-button
          >
        </div>
      </div>
    </div>
    <!-- 添加商品 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="60%"
      :before-close="handleClose"
    >
      <div class="dialog_box">
        <p class="con_title dialog_title">Add Products</p>
        <el-input
          class="search_input2"
          v-model="searchSpuWords"
          prefix-icon="el-icon-search"
          placeholder="Search Product Name/SKU"
          clearable
          @change="loadGoodsDetail()"
        />
        <el-collapse
          v-model="activeNames"
          v-for="(node, index) in allProduct"
          :id="'cust_tablist_'+node.id"
          :key="index"
        >
          <el-collapse-item :name="node.id" :id="node.id">
            <template slot="title">
              <el-checkbox
                v-model="node.skuAll"
                :id="'cust_spu_'+node.id"
                @change="handleCheckAllChange($event,node.id, node.skuAll)"
              >
                <div class="custom-tree-node flex">
                  <img class="sku_img" :src="node.imgUrl" alt=""/>
                  <p class="spu_title">{{ node.title }}</p>
                </div>
              </el-checkbox>
            </template>
            <!-- <div class="sku_box"></div> -->
            <el-checkbox-group
              v-model="checkedCities"
              @change="handleCheckedCitiesChange($event, node.id)"
              class="checkout_style flex"
            >
              <el-checkbox
                v-for="(sku, i) in node.skus"
                :label="sku.id"
                :key="i"
              >
                <div class="sku_size flex">
                  <p>{{ sku.character }}</p>
                  <p>
                    <span>{{ sku.skuCode }}</span>
                    <span>{{ sku.vdSku }}</span>
                    <span>${{ getPrice(sku) }}</span>
                  </p>
                </div>
              </el-checkbox>
            </el-checkbox-group>
          </el-collapse-item>
        </el-collapse>
        <div class="more_text" v-if="allProduct.length == 0">No results found for {{ searchSpuWords }}</div>
        <div class="more_text" v-if="allProduct.length>0">Default Display 30 items, you could search for more</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="addProduct()">Add</el-button>
      </span>
      <p class="all_select_num" v-if="allProduct.length == 0">{{ allProduct.length }}Variant Selected</p>
      <p class="all_select_num" v-if="allProduct.length>0">{{ checkedCities.length }}Variant Selected</p>
    </el-dialog>
    <el-dialog
      :visible.sync="successVisible"
      :close-on-click-modal="false"
      :show-close="false"
      width="30%"
      @close="backOrderList()"
    >
      <span class="back_icon" @click="backOrderList()"><i class="el-icon-arrow-left"></i>Back</span>
      <p class="success_text">Order modified successfully</p>
      <div class="flex_all">
        <el-button
          type="primary"
          class="back_button"
          @click="backOrderList()"
        >Back Order List ({{ seconds }})
        </el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="notEnoughVisible"
      :close-on-click-modal="false"
      :show-close="false"
      width="30%"
      @close="backOrderList()"
    >
      <span class="back_icon" @click="backOrderList()"><i class="el-icon-arrow-left"></i>Back</span>
      <p class="success_text">Order modified successfully</p>
      <div class="not_enough">The client doesn’t have enough credit, he could pay this order with card.</div>
      <div class="flex_all">
        <el-button
          type="primary"
          class="back_button"
          @click="backOrderList()"
        >Back Order List ({{ seconds }})
        </el-button
        >
      </div>
    </el-dialog>
    <div>
      <Address ref="address" :addressMessage="addressMessage"/>
    </div>
  </div>
</template>

<script>
import {postAction, getAction} from '@/api/manage.js'
import Address from '@/pages/components/address.vue'
import CustomBreadcrumb from '../components/custom-breadcrumb'

export default {
  components: {
    Address, CustomBreadcrumb
  },
  data() {
    return {
      userId: this.$ls.get('userInfo').id,
      seconds: 5,
      memo: '', // memo绑定值
      addressId: '', // 地址id
      addressType: false, // 弹窗
      deleteLine: false,
      allProductQty: 0,
      successVisible: false,
      notEnoughVisible: false,
      skuEdit: true,
      searchWords: '',
      searchSpuWords: '',
      dialogVisible: false,
      disabled: false,
      retailerInfo: [],
      reInfo: {},
      activeNames: ['1'],
      wholesalePrice: '',
      itemTotel: 0,
      wholesaleNum: '',
      orderDiscount: 0,
      shippingDiscount: 0,
      totalPriceOfGoods: 0,
      goodsDiscount: 0,
      shippingPrice: 0,
      totalAmount: 0,
      orderDetails: [],
      checkAllSpuIdArr: [],
      checkedCities: [],
      isIndeterminate: true,
      allProduct: [],
      createOrderId: '',
      // 所有的spu和sku
      spuWithSkuArrMap: new Map(),
      addressMessage: {},
      createOrderLoading: false,
      brandName: '',
      shopvidiLogisticsUndertakeFlag: false, // true:shopvidi承担物流
      isOperationAccount: false, // 是否为运营账号
      isShippingFree: false, // 品牌是否免邮
      supplierManagementModelFlag: false, // 判断是入住还是自营 true：入驻
      totalInfo: {
        fobSubtotal: 0, // 订单离岸价
        cifSubTotal: 0, // 订单原始到岸价
        totalQuantity: 0, // 该订单下了多少个件商品
        totalPriceBefore: 0, // 该订单的优惠前金额
        totalPriceProductDicounted: 0, // 该订单商品优惠的金额
        totalPriceOrderDiscounted: 0, // 该订单  订单优惠金额
        totalPriceOrderDiscountedShopvidi: 0, // 该订单shopvidi优惠金额[优惠券]
        totalPrice: 0, // 该订单优惠后金额
        totalFreightPriceBefore: 0, // 该订单物流 优惠前金额
        totalFreightPriceDiscounted: 0, // 该订单物流优惠金额
        totalFreight: 0, //
        subTotal: 0,
        payAmount: 0, // 订单实付金额
        shippingDiscount: 0 // 物流优惠金额
      }
    }
  },
  created() {
    this.loadRetailerInfo()
    //   this.loadLogisticsUndertaker()
    this.loadRole()
    this.loadBrand()
  },
  filters: {
    fixed2: (v) => {
      let num = parseFloat(v), digit = 2
      return (Math.round((num + Number.EPSILON) * Math.pow(10, digit)) / Math.pow(10, digit)).toFixed(digit)
      // return v ? Number(v).toFixed(2) : v;
    }
  },
  methods: {
    getPrice(sku) {
      let priceReal = sku.price
      if (sku['procurementConstructList'] && sku['procurementConstructList'].length > 0) {
        for (let k = 0; k < sku['procurementConstructList'].length; k++) {
          // 转一下String 防止类型不一致
          const wholesalerCustomer = sku['procurementConstructList'][k]['wholesalerCustomer'] + ''
          if (wholesalerCustomer === this.userId.toString()) {
            priceReal = sku['procurementConstructList'][k]['wholesalePrice']
            break
          }
        }
      }
      return priceReal
    },
    async loadBrand() {
      let res = await getAction(`/sp/suppliers/suppiler-brands`)
      let brandArr = res['result']
      // 没有配置品牌
      if (!brandArr || brandArr.length === 0) {
        this.$message.warning('misconfiguration')
        return
      }
      this.isShippingFree = brandArr[0]['shippingFree'] == '1'
    },
    async loadRole() {
      let roleData = await getAction(`/sp/suppliers/own-brand`)
      this.isOperationAccount = roleData['result']['model'] === '4'

      if (this.shopvidiLogisticsUndertakeFlag && !this.isOperationAccount) {
        this.disabled = true
      }

      // 此处不调用后端了，采用前端的方式来处理，判断localStorage
      let userInfo = JSON.parse(localStorage.getItem('pro__userInfo')).value
      if (userInfo.supplierManagementModel === 1) {
        this.supplierManagementModelFlag = true
      } else {
        this.supplierManagementModelFlag = false
      }
    },
    memoChange(e) {
      if (e.keyCode === 13) {
        e.returnValue = false
      }
    },
    openAddress() {
      this.addressMessage = {
        addressId: this.addressId,
        userId: this.reInfo.id
      }
      this.$refs.address.dialogVisible = true
    },
    countdown() {
      if (this.seconds === 0) {
        this.backOrderList()
      } else {
        this.seconds--
        this.timer = setTimeout(this.countdown, 1000)
      }
    },
    backOrderList() {
      clearTimeout(this.timer)
      this.successVisible = false
      this.notEnoughVisible = false
      this.$router.push({path: 'refer-orders'})
    },
    toOrders() {
      this.$router.push({path: 'refer-orders'})
    },
    addProduct() {
      this.dialogVisible = false
      for (let j = 0; j < this.allProduct.length; j++) {
        const spu = this.allProduct[j]
        for (let i = 0; i < spu.skus.length; i++) {
          const sku = spu.skus[i]
          // addProducts
          if (this.checkedCities.includes(sku.id) && !this.orderDetails.some(detail => detail.skuId === sku.id)) {
            let priceReal = this.getPrice(sku)
            let obj = {
              skuId: sku.id,
              goodsId: spu.id,
              title: spu.title,
              img: sku.imgPath,
              price: priceReal, // cifPrice
              priceBefore: priceReal, // cifPrice
              sum: 1,
              total: priceReal * 1,
              newPrice: priceReal,
              weight: sku.weight != null ? sku.weight : 0,
              size: sku.character,
              skuName: sku.skuName,
              fobPrice: sku.fobPrice,
              fobPriceBefore: sku.fobPrice,
              skuCode: sku.vdSku,
              isShippingFree: spu.isFreeShipping,
              brandId: spu.collectionBrandId
            }
            this.orderDetails.push(obj)
          }
        }
      }
      if (this.allProduct) {
        this.brandName = this.allProduct[0]['collectionBrandName']
      }
      this.countShipping()
    },
    changeNum(e, idx, row) {
      let value = Number(e)
      if (value) {
        this.$set(this.orderDetails[idx], 'total', (value * row['priceBefore']).toFixed(2))

        // 如果修改了数量，则物流费重置、优惠（品牌优惠）清0
        this.totalInfo['totalPriceOrderDiscounted'] = 0
        this.totalInfo['totalFreight'] = 0

        this.countShipping()
      }
    },
    changeFobPrice(newPriceStr, idx, row) {
      let newPrice = Number(newPriceStr)
      if (newPrice) {
        let oldPrice = row['fobPriceBefore']
        if (newPrice > Number(oldPrice)) {
          this.$set(this.orderDetails[idx], 'fobPrice', oldPrice.toFixed(2))
          this.$message.warning('Discount price should\'t larger than original Price')
          return
        }
        // CIF = FOB+履约服务费
        let servicePrice = Number(row['priceBefore']) - Number(row['fobPriceBefore'])
        this.$set(this.orderDetails[idx], 'price', (newPrice + servicePrice).toFixed(2))
      } else {
        this.$set(this.orderDetails[idx], 'price', row['priceBefore'].toFixed(2))
        this.$set(this.orderDetails[idx], 'fobPrice', row['fobPriceBefore'].toFixed(2))
      }

      // 如果修改了商品价格、数量，则品牌优惠要清0
      this.totalInfo['totalPriceOrderDiscounted'] = 0

      this.countAllTotal()
    },
    // 计算订单创建前所有价格
    countAllTotal() {
      this.totalPriceOfGoods = 0
      this.goodsDiscount = 0
      this.allProductQty = 0
      this.totalAmount = 0
      let itemArr = []
      this.orderDetails.forEach((sku) => {
        itemArr.push({
          skuId: sku.skuId,
          goodsId: sku.goodsId,
          title: sku.title,
          img: sku.img,
          price: sku.price,
          priceBefore: sku.priceBefore,
          sum: sku.sum,
          total: (sku.priceBefore * sku.sum),
          newPrice: sku.newPrice ? sku.newPrice : sku.price,
          weight: sku.weight,
          size: sku.size,
          skuName: sku.skuName,
          fobPrice: sku.fobPrice,
          fobPriceBefore: sku.fobPriceBefore,
          skuCode: sku.skuCode,
          deleteLine: false,
          brandId: sku.brandId
        })
      })
      this.orderDetails = itemArr

      /* this.orderDetails.forEach((newsku) => {
         this.totalPriceOfGoods += Number(newsku.price * newsku.sum)
         this.goodsDiscount += Number(newsku.price * newsku.sum) - (Number(newsku.newPrice) * Number(newsku.sum))
         this.allProductQty += Number(newsku.sum)
         if (newsku.newPrice && newsku.newPrice < newsku.price) {
           newsku.deleteLine = true
         } else {
           newsku.deleteLine = false
         }
       })
       this.totalPriceOfGoods = this.totalPriceOfGoods.toFixed(2)
       this.goodsDiscount = this.goodsDiscount.toFixed(2)
       this.totalAmount = Math.abs(Number(this.totalPriceOfGoods) + Number(this.shippingDiscount) - (Number(this.orderDiscount) + Number(this.goodsDiscount))).toFixed(2)
       */
      this.builderTotalInfo()
    },
    handleCheckAllChange(val, spuId, sku) {
      // add by cpgu 2022/05/14 begin
      if (val) {
        this.checkAllSpuIdArr.push(spuId)
        this.checkedCities = this.checkedCities.concat(this.spuWithSkuArrMap.get(spuId))
      } else {
        let netArr = [...this.checkedCities]
        this.checkedCities = netArr.filter(sltSku => {
          return !sku.includes(sltSku)
        })

        let spuIdSltArr = [...this.checkAllSpuIdArr]
        spuIdSltArr = spuIdSltArr.filter(sltSpuId => {
          return sltSpuId != spuId
        })
        this.checkAllSpuIdArr = spuIdSltArr
      }
      // end by cpgu
    },
    handleCheckedCitiesChange(value, spuId) {
      let checkedCount = value.length
      /* this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.cities.length; */

      // add by cpgu 2022/05/11   begin
      let skuIdArr = this.spuWithSkuArrMap.get(spuId) ? this.spuWithSkuArrMap.get(spuId) : []
      // value是所有选中值的数组
      let checkedArr = skuIdArr.filter(sltSku => {
        return value.includes(sltSku)
      })
      let labObj = document.getElementById('cust_spu_' + spuId)
      let itmObj = document.getElementById(spuId)
      let arr = labObj.getAttribute('class').split(' ')
      let arrItm = itmObj.getAttribute('class').split(' ')
      if (checkedArr.length == skuIdArr.length) {
        this.updateCheckAllClass(arr, labObj, 'is-checked', true)
        this.updateCheckAllClass(arr, labObj, 'is-indeterminate', false)
        this.updateItmClass(arrItm, itmObj, 'is-active', false, spuId)
      } else if (checkedArr.length > 0 && skuIdArr.length > checkedArr.length) {
        this.updateCheckAllClass(arr, labObj, 'is-checked', false)
        this.updateCheckAllClass(arr, labObj, 'is-indeterminate', true)
        this.updateItmClass(arrItm, itmObj, 'is-active', true, spuId)
      } else {
        this.updateCheckAllClass(arr, labObj, 'is-checked', false)
        this.updateCheckAllClass(arr, labObj, 'is-indeterminate', false)
        this.updateItmClass(arrItm, itmObj, 'is-active', true, spuId)
      }
      // end by cpgu
    },
    updateItmClass(arr, labObj, className, isAdd, spuId) {
      if (isAdd) {
        if (!arr.includes(className)) {
          labObj.classList.add(className)
          labObj.children[0].setAttribute('aria-expanded', 'true')
          labObj.children[1].style.display = 'block'
        }
        this.activeNames.push(spuId)
      } else {
        if (arr.includes(className)) {
          labObj.classList.remove(className)
          labObj.children[0].setAttribute('aria-expanded', 'false')
          labObj.children[1].style.display = 'none'
        }
        if (this.activeNames.includes(spuId)) {
          let actNmas = [...this.activeNames]
          actNmas = actNmas.filter(name => {
            return name !== spuId
          })
          this.activeNames = actNmas
        }
      }
    },
    updateCheckAllClass(arr, labObj, className, isAdd) {
      if (isAdd) {
        if (!arr.includes(className)) {
          labObj.classList.add(className)
          labObj.children[0].classList.add(className)
        }
      } else {
        if (arr.includes(className)) {
          labObj.classList.remove(className)
          labObj.children[0].classList.remove(className)
        }
      }
    },
    handleClose(done) {
      this.dialogVisible = false
    },
    addProductHandel() {
      this.dialogVisible = true
      this.loadGoodsDetail()
    },
    handleCheckChange(data, checked, indeterminate) {
      console.log(data, checked, indeterminate)
    },
    handleNodeClick(data) {
      console.log(data)
    },
    changSelectHandel() {
      this.loadRetailerInfo()
    },
    async loadRetailerInfo() {
      await getAction('/sp/suppliers/retailers?keyWords=' + this.searchWords).then(
        (res) => {
          if (res.success) {
            this.retailerInfo = res.result
            this.reInfo = res.result ? res.result[0] : []
            this.addressId = res.result ? res.result[0]['addressId'] : []
            // 查询发货地
            this.loadLogisticsUndertaker()
          } else {
            this.$message.warning(res.message)
          }
        }
      )
    },
    /**
     * 物流承担方
     */
    async loadLogisticsUndertaker() {
      let res = await getAction('/v0.2/brand/orders/logistics-under-writer', {userId: this.reInfo.id})
      this.shopvidiLogisticsUndertakeFlag = res.result
    },
    loadGoodsDetail() {
      const supplierId = this.$ls.get('userInfo').id
      getAction(
        `/product/api/v0.2/suppliers/${supplierId}/products?keywords=` + this.searchSpuWords +
        '&procurementStockFlag=1').then((res) => {
        if (res.success) {
          this.allProduct = res.result.records
          this.selAll()

          // add by cpgu 2022/05/11 begin
          if (this.allProduct) {
            let spuIdArr = []
            this.allProduct.forEach(spu => {
              this.spuWithSkuArrMap.set(spu.id, spu.skus.map(sku => sku.id))
              spuIdArr.push(spu.id)
            })
            this.activeNames = spuIdArr
          }
          // end by cpgu
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    createOrder() {
      if (this.createOrderLoading) {
        return
      }
      if (this.retailerInfo.length !== 1) {
        return this.$message.warning(
          'You have not selected a retailer user yet'
        )
      }
      if (this.orderDetails.length === 0) {
        return this.$message.warning(
          'You have not selected an item yet'
        )
      }
      if (!this.addressId) {
        return this.$message.warning(
          'Retailer shipping address is not added'
        )
      }
      let goodsList = this.orderDetails.map((o, i) => {
        return {
          goodsId: o.goodsId,
          skuId: o.skuId,
          quantity: o.sum,
          skuName: o.skuName,
          skuImg: o.img,
          character: o.size,
          price: o.fobPriceBefore, // fob
          nominalPrice: o.priceBefore, // cif优惠前价
          unitPriceAfterDiscount: o.price, // 修改后cif价（优惠后）
          brandId: o.brandId
        }
      })
      const params = {
        userId: this.reInfo.id,
        discountPrice: this.totalInfo['totalPriceOrderDiscounted'],
        goodDetails: goodsList,
        addressId: this.addressId,
        memo: this.memo
      }
      this.createOrderLoading = true
      // console.log('当前的传参', params)
      postAction('/v0.2/brand/orders', params).then((res) => {
        if (res.success) {
          this.createOrderId = res.result.orderId
          this.postConfirmOrder()
        } else {
          this.$message.warning(res.message)
          this.createOrderLoading = false
        }
      })
    },
    deleteOrder(data) {
      // 删除添加订单
      this.checkedCities.map((e, i) => {
        if (e === data.skuId) {
          this.checkedCities.splice(i, 1)
        }
      })
      // 清空品牌优惠
      this.totalInfo['totalPriceOrderDiscounted'] = 0
      this.orderDetails.map((e, i) => {
        if (e.skuId === data.skuId) {
          this.orderDetails.splice(i, 1)
          this.shippingDiscount = 0
          this.orderDiscount = 0
          this.countAllTotal()
          if (this.orderDetails.length > 0) {
            this.countShipping()
          } else {
            this.shippingPrice = 0
            this.totalAmount = 0
          }
        }
      })
    },
    postConfirmOrder() {
      const confirmParams = {
        tsStoreAddressInfo: {
          'uid': this.reInfo.addressId,
          'name': this.reInfo['addressFirstName'],
          'lastname': this.reInfo['addressLastName'],
          'areaCode': this.reInfo['areaCode'],
          'phone': this.reInfo['addressPhone'],
          'address': this.reInfo['address'],
          'country': this.reInfo['country'],
          'province': this.reInfo.province,
          'city': this.reInfo.city,
          'postCode': this.reInfo.postCode,
          'isDefaultAddress': 1,
          'countryName': this.reInfo.countryName,
          'userId': this.reInfo.id
        },
        payMethod: '3',
        userId: this.reInfo.id,
        couponInfo: {
          'couponId': '',
          'couponPrice': 0
        },
        orderInfoList: [
          {
            'orderId': this.createOrderId,
            'logisticsUnderWriter': this.shopvidiLogisticsUndertakeFlag,
            'totalPriceBefore': this.totalPriceOfGoods,
            'totalFreightBefore': this.shippingPrice,
            'discountedFreight': this.totalInfo.shippingDiscount
          }

        ]
      }
      postAction('/v0.2/brand/orders/confirm', confirmParams).then(
        (res) => {
          if (res.success) {
            this.createOrderLoading = false
            this.successVisible = true
            this.countdown()
            // this.$message.success("Order created successfully");
          } else {
            // notes 增加提示
            this.createOrderLoading = false
            this.notEnoughVisible = true
            this.countdown()
          }
        }
      )
    },
    // 计算运费
    countShipping() {
      let freightParams = []
      for (let z = 0, len = this.orderDetails.length; z < len; z++) {
        const sku = this.orderDetails[z]
        debugger
        let pam = {
          skuId: sku.skuId,
          goodsId: sku.goodsId,
          weight: sku.weight,
          num: Number(sku.sum),
          isFreeShipping: sku.isFreeShipping
        }
        freightParams.push(pam)
      }
      postAction('/product/api/v0.2/batch_orders/freight', freightParams).then((res) => {
        if (res.success) {
          this.shippingPrice = Number(res.result)
          this.totalInfo['shippingDiscount'] = 0
          this.countAllTotal()
          console.log('已计算运费', this.shippingPrice)
        }
      })
    },

    selSkuId(array) {
      let arr2 = []
      array.forEach((item) => {
        arr2.push(item.id)
      })
      return arr2
    },
    // 给每个spu添加skuid的集合
    selAll() {
      let curPageData = []
      this.allProduct.map((item, index) => {
        curPageData.push(
          Object.assign({}, item, {
            skuAll: this.selSkuId(item.skus)
          })
        )
      })
      this.allProduct = curPageData
      console.log(this.allProduct, '全部商品')
    },
    changePrice(value) {
      if (Number(value) > (Number(this.totalInfo.cifSubTotal) - Number(this.totalInfo.totalPriceProductDicounted)).toFixed(2)) {
        this.totalInfo.totalPriceOrderDiscounted = 0
      } else {
        this.totalInfo.totalPriceOrderDiscounted = !value ? 0 : value
      }

      this.countAllTotal()
    },
    changeShipping(value) {
      const reg = /^([0-9]|[1-9]\d+)(\.\d{1,2})?$/
      if (reg.test(value)) {
        // if (Number(value) > Number(this.shippingPrice)) {
        //   this.shippingDiscount = 0
        // } else {
        this.shippingDiscount = value
        // }
      } else {
        this.shippingDiscount = 0
      }
      this.countAllTotal()
    },
    changeTotalFreight(v) {
      v = v || 0
      this.totalInfo['payAmount'] = Number(v) + this.totalInfo['subTotal']
      this.totalInfo['totalFreight'] = v
      this.builderTotalInfo()
    },

    buildFobWithCif() {
      this.totalInfo.fobSubtotal = 0
      this.totalInfo.cifSubTotal = 0
      this.orderDetails.map((e, i) => {
        this.totalInfo.fobSubtotal += (Number(e['fobPrice']) * Number(e['sum']))
        this.totalInfo.cifSubTotal += (Number(e['priceBefore']) * Number(e['sum']))
      })
    },
    builderTotalInfo() {
      this.buildFobWithCif()
      this.totalInfo.totalPriceProductDicounted = 0
      let goodsNum = 0
      this.orderDetails.map((e, i) => {
        this.totalInfo.totalPriceProductDicounted += (Number(e['priceBefore']) - Number(e['price'])) * Number(e['sum'])
        goodsNum += Number(e['sum'])
      })
      this.totalInfo['subTotal'] = Number(this.totalInfo['cifSubTotal']) - Number(this.totalInfo['totalPriceProductDicounted']) - Number(this.totalInfo['totalPriceOrderDiscounted']) - Number(this.totalInfo['totalPriceOrderDiscountedShopvidi'])
      // this.totalInfo['payAmount'] = this.totalInfo['subTotal'] + Number(this.totalInfo['totalFreight'])
      this.totalInfo['totalQuantity'] = goodsNum.toFixed(0)

      // 修改用
      this.allProductQty = goodsNum
      this.totalPriceOfGoods = this.totalInfo.cifSubTotal
      this.goodsDiscount = this.totalInfo.totalPriceProductDicounted
      /* this.tsStoreOrderInfo['orderDiscounted']=this.totalInfo.totalPriceOrderDiscounted;
       this.tsStoreOrderInfo['couponPrice']=this.totalInfo.totalPriceOrderDiscountedShopvidi;
       this.tsStoreOrderInfo['totalFreight']=this.totalInfo.totalFreight; */
      // this.totalAmount = this.totalInfo.payAmount
      this.handleShippingDiscount()
    },

    handleShippingDiscount() {
      if (this.shippingPrice < this.totalInfo['shippingDiscount']) {
        this.totalInfo['shippingDiscount'] = this.shippingPrice
      }
      if (!this.totalInfo['shippingDiscount']) {
        this.totalInfo['shippingDiscount'] = 0
      }
      this.totalAmount = this.totalInfo['subTotal'] + Number(this.shippingPrice - this.totalInfo['shippingDiscount'])
      this.totalInfo['payAmount'] = this.totalAmount
    }
  }
}
</script>

<style scoped lang="less">
/deep/ .el-select .el-input__inner {
  width: 380px !important;
  margin-left: 16px;
}

.el-select-dropdown__item {
  height: 60px !important;
  line-height: 26px !important;
}

.checkout_style {
  // margin-left: 30px;
  flex-direction: column;
}

/deep/ .el-collapse {
  border: none;
}

/deep/ .el-collapse-item__wrap {
  border-bottom: none !important;
}

/deep/ .checkout_style .el-checkbox {
  padding-left: 30px;
  width: 96%;
}

/deep/ .el-checkbox {
  display: flex;
  align-items: center;
  width: 100%;
  padding-bottom: 10px;
  border-bottom: #e1e1e1 solid 1px;
}

/deep/ .el-input--suffix .el-input__inner {
  padding-right: 10px !important;
}

/deep/ .el-tree-node__content {
  height: 80px;
}

/deep/ .el-checkbox__inner {
  border-color: #262b2f !important;
}

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
  background: #262b2f !important;
  border-color: #262b2f !important;
}

/deep/ .brown_text .el-input__inner {
  color: #c3824b;
}

/deep/ .el-button--primary {
  width: 90px;
  height: 40px;
  background: #262b2f;
  border: none;
  border-radius: 3px;
}

.gery_color {
  color: #8f8f8f;
  cursor: pointer;
}

.order_search {
  height: auto;
  border: 1px solid #e1e1e1;
  margin: 0 0 20px 25px;
  padding: 14px 0;
}

.con_title {
  margin-bottom: 15px;
  font-size: 14px;
  font-family: Graphik;
  font-weight: 500;
  color: #262b2f;
  margin-left: 30px;
}

.search_input2 {
  width: 40%;
  margin-left: 30px;
}

.creat_order {
  margin-left: 30px;
}

.prduct_box {
  display: flex;

  .product_img {
    width: 80px;
    height: 80px;
    border: 1px solid #e1e1e1;
  }

  .product_info {
    display: flex;
    flex-direction: column;
    font-size: 14px;
    font-family: Graphik;
    font-weight: 400;
    line-height: 20px;
    color: #262b2f;
    padding: 12px 0 0 12px;
  }

  .dis_price {
    margin-left: 10px;
  }

  .dis_line {
    text-decoration: line-through;
  }
}

.price_input {
  width: 80px;
  height: 40px;
}

.black_text {
  color: #262b2f;
  margin-right: 3px;
}

.brown_text {
  color: #c3824b;
}

.add-btn {
  background-color: #262b2f;
  border-color: #262b2f;
  width: 192px;
  height: 38px;
  border-radius: 3px;
  margin-top: 20px;
  cursor: pointer;
}

.end_box {
  width: 90%;
  margin-left: 30px;
  padding-bottom: 50px;
  flex-direction: column;
  align-items: flex-end;

  .creat_text {
    width: 50%;
    height: 40px;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    font-family: Graphik;
    font-weight: 400;
  }

  .blod_text {
    font-size: 16px;
    font-family: Graphik;
    font-weight: 500;
    color: #262b2f;
  }

  .split {
    border-bottom: 1px solid #E1E1E1;
    width: 100%;
  }
}

.search_content {
  padding-top: 10px;

  .con_left {
    width: 32%;
  }

  .user_info {
    margin-left: 30px;
    font-size: 14px;
    font-family: Graphik;
    font-weight: 400;
    line-height: 18px;
    color: #5d5d5d;

    .info_text {
      color: #262b2f;
    }
  }
}

.dialog_title {
  padding-top: 20px;
}

.sku_img {
  width: 60px;
  height: 60px;
  border: 1px solid #e1e1e1;
}

.dialog_box {
  max-height: 500px;
  overflow: scroll;
}

.custom-tree-node {
  width: 100%;

  .spu_title {
    width: 600px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-left: 10px;
  }

  .sku_name {
    margin: 10px 0 0 10px;
  }

  .dialog-footer {
    position: fixed;
    bottom: 0;
    left: 0;
  }
}

.sku_size {
  width: 700px;
  height: 40px;
  padding: 0 40px 0 10px;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  font-family: Graphik;
  font-weight: 400;
  line-height: 20px;
  color: #262b2f;
  // border-bottom: #e1e1e1 solid 1px;
  span {
    margin-left: 10px;
  }
}

.all_select_num {
  position: absolute;
  bottom: 30px;
  left: 20px;
  color: #262b2f;
}

.back_icon {
  font-size: 14px;
  font-family: Avenir;
  font-weight: 500;
  line-height: 40px;
  color: #262b2f;
  margin: 0 0 0 10px;
  cursor: pointer;
}

.success_text {
  font-size: 14px;
  font-family: Graphik;
  font-weight: 600;
  line-height: 18px;
  color: #262b2f;
  text-align: center;
  margin-top: 10px;
}

.back_button {
  width: 144px;
  height: 41px;
  border: 1px solid #707070;
  border-radius: 3px;
  margin: 30px 0;
}

.re_text {
  flex-direction: column;
  height: 40px;

  .span_margin {
    padding: 0 2px;
  }
}

.more_text {
  margin: 10px 0;
  text-align: center;
}

.order-delete {
  cursor: pointer;
  padding-left: 10px;
  font-size: 16px;
}

.qty-left {
  display: flex;
  justify-content: left;
}

.product-bottom {
  display: flex;
  justify-content: space-between;

  .product-bottom-memo {
    padding-left: 25px;
    padding-top: 21px;
    width: 657px;
    height: 161px;

    .memo-text {
      padding-bottom: 19px;
    }
  }

  .product-bottom-price {
    width: 800px;
  }
}

.not_enough {
  text-align: center;
  padding: 20px;
  height: 33px;
  font-size: 12px;
  font-family: Graphik;
  font-weight: 400;
  line-height: 18px;
  color: #262B2F;
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/pages/vidirect/create-refer-order.vue